import React from "react"
import ArticleCard from "./article-card"
import { motion } from "framer-motion"

const gridAnimate = {
  offScreen: { opacity: 0, y: 50 },
  onScreen: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", bounce: 0.4, duration: 2 },
  },
}

const ArticlesGrid = ({ articles }) => {
  return (
    <motion.div
      className="grid-recommend"
      variants={gridAnimate}
      initial={"offScreen"}
      whileInView={"onScreen"}
      transition={{ staggerChildren: 0.2 }}
    >
      <div className="testimonial_text">
        {articles.map((article, index) => (
          <ArticleCard key={index} article={article} />
        ))}
      </div>
    </motion.div>
  )
}

export default ArticlesGrid
